import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DadosTemplateEntrada } from 'src/app/model/DadosTemplateEntrada';
import { ResponseNet } from 'src/app/model/ResponseNet.model';
import { ResponseUser } from 'src/app/model/User.model';
import { AjaxService } from 'src/app/service/ajax.service';
import { AuthService } from 'src/app/service/auth.service';
import { UtilService } from 'src/app/service/util.service';
import { API, maskCPF, maskTelefoneCelular, numberMaskInt, numberMaskReal } from 'src/environments/environment';


@Component({
  selector: 'app-cadastro-triagem',
  templateUrl: './cadastro-triagem.component.html',
  styleUrls: ['./cadastro-triagem.component.scss']
})
export class CadastroTriagemComponent implements OnInit {

  maskCPF = maskCPF;
  maskTelefoneCelular = maskTelefoneCelular;
  numberMaskInt = numberMaskInt;
  numberMaskReal = numberMaskReal;

  habilitarForm: boolean;
  user: ResponseUser;
  arrayTipos: any;
  campoLabel: string;
  descricaoLabel: string;

  arraySelectOpcao: string[];
  tipoCampoSelecionado: string;
  ehObrigatorio: boolean;

  nome: string;
  descricao: string;
  selectedItem: any;

  arrayFormulario: DadosTemplateEntrada[];
  inputOpcoes: string;

  arrayProgramas: any;
  programaSelecionado: any;
  uploadedFilesCapa: File;
  descricaoQrcode: string;
  dataInicial: string;
  dataFinal: string;



  public rateSquare = 2;

  constructor(
    private router: Router,
    private ajax: AjaxService,
    public util: UtilService,
    private auth: AuthService
  ) {
    this.habilitaForm();
  }

  buscarProgramas() {
    this.util.showLoading();
    let url = API + "Programa/Programa";
    return this.ajax.get(url)
      .subscribe(response => {
        this.arrayProgramas = this.util.convertIoptions(response.data, "iD_PROGRAMA", "descricao");
        this.util.closeLoading();
      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao Buscar Programa");
      });
  }

  buscaQtdSeccsao() {
    let numpagina = 0;
    debugger
    this.arrayFormulario.forEach(item => {
      if (item.paginaCabecalho)
        numpagina++
    });
    return numpagina;
  }

  atualizarpagina() {
    let numpagina = this.buscaQtdSeccsao();
    let pagina = 0;
    debugger
    this.arrayFormulario.forEach(item => {
      if (item.paginaCabecalho) {
        pagina++;
        //item.pagina = `${pagina}/${numpagina}`;
        item.pagina = pagina;
      }
    });
  }


  removerpagina() {
    if (this.buscaQtdSeccsao() > 1) {
      this.selectedItem.paginaCabecalho = false;
      this.atualizarpagina();
    } else {
      this.util.toasterShowInfo("Atenção", "Não é permitido remover esta Secção");
    }

  }

  adicionarpagina() {
    this.selectedItem.paginaCabecalho = true;
    this.atualizarpagina();

  }

  habilitaForm() {
    this.habilitarForm = true;
  }

  desabilitaForm() {
    this.habilitarForm = false;
  }

  ngOnInit() {
    this.user = this.auth.getUser();
    this.buscarTipos();
    this.arrayFormulario = [];
    this.arraySelectOpcao = [];
    this.nome = "";
    this.descricao = "";
    this.ehObrigatorio = false;
  }

  validaAdd() {
    if (this.campoLabel == undefined || this.campoLabel == "") {
      this.util.toasterShowError("Atenção", "Entre com a Descricao do Campo");
      return false;
    }

    if (this.tipoCampoSelecionado == "8") { // select
      if (this.arraySelectOpcao == undefined || this.arraySelectOpcao.length == 0) {
        this.util.toasterShowError("Atenção", "Digite com ao menos uma opção");
        return false;
      }
    }

    return true;
  }

  ajustaValorSelecao() {
    debugger
    let valores = [];
    for (let item of this.arraySelectOpcao) {
      valores.push(item['value']);
    }
    return valores;
  }

  addOpcao() {
    debugger
    if (this.inputOpcoes != undefined && this.inputOpcoes != "") {
      this.arraySelectOpcao.push(this.inputOpcoes);
      this.inputOpcoes = "";
    } else {
      this.util.toasterShowWarning("Atenção", "Digite uma opção válida!");
    }
  }

  removeOpcao(index) {
    this.arraySelectOpcao.splice(index, 1);
  }


  addItem() {
    debugger
    if (this.validaAdd()) {
      let dados = new DadosTemplateEntrada();
      dados.valores = [];
      dados.titulo = this.campoLabel;
      dados.descricao = this.descricaoLabel;
      dados.iD_TIPO_CAMPO_FORMULARIO = parseInt(this.tipoCampoSelecionado);
      dados.ordem = this.arrayFormulario.length + 1;
      dados.obrigatorio = this.ehObrigatorio;
      //dados.pagina = "1/1";
      dados.pagina = 1;
      dados.paginaCabecalho = this.arrayFormulario.length == 0 ? true : false;
      let tipo = this.arrayTipos.find(c => c.id == this.tipoCampoSelecionado);

      if (tipo.id == "8") {// selecao de dados
        dados.valores = this.ajustaValorSelecao();
      } else if (tipo.id == "9" || tipo.id == "10") {// check ou radio
        dados.valores = this.arraySelectOpcao;
      }

      debugger
  

      this.arrayFormulario.push(dados);
      this.limparItem();
    }

  }

  limparItem() {
    this.campoLabel = "";
    this.arraySelectOpcao = [];
    this.ehObrigatorio = false;
    this.descricaoLabel = "";
    //this.desabilitaForm();
  }

  onItemSelect(item) {
    if (item.mode != 'empty') {
      this.selectedItem = item;
    }
  }

  moveUp() {
    let index = this.arrayFormulario.indexOf(this.selectedItem);
    this.arrayFormulario[index].ordem = this.arrayFormulario[index].ordem - 1;
    this.arrayFormulario[index - 1].ordem = this.arrayFormulario[index].ordem + 1;
    this.sortItemsByPostion();
  }

  moveDown() {
    let index = this.arrayFormulario.indexOf(this.selectedItem);
    this.arrayFormulario[index].ordem = this.arrayFormulario[index].ordem + 1;
    this.arrayFormulario[index + 1].ordem = this.arrayFormulario[index].ordem - 1;
    this.sortItemsByPostion();

  }

  sortItemsByPostion() {
    this.arrayFormulario = this.arrayFormulario.sort((opt1, opt2) => {
      if (opt1.ordem < opt2.ordem) {
        return -1;
      }
      if (opt1.ordem > opt2.ordem) {
        return 1;
      }
      return 0
    });
  }

  deleteItem(index) {
    this.arrayFormulario.splice(index, 1);
  }

  buscarTipos() {
    this.util.showLoading();
    var url = API + 'TipoCampoFormulario/TipoCampoFormulario';
    this.ajax.get(url)
      .subscribe(resp => {
        console.log(resp);
        this.arrayTipos = resp.data;
        this.tipoCampoSelecionado = "1"; // texto livre
        this.util.closeLoading();
        this.buscarProgramas();

      }, err => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Erro ao buscar Dados");
      });
  }

  validarTriagem() {
    
    if (this.programaSelecionado == undefined || this.programaSelecionado == null) {
      this.util.toasterShowError("Atenção", "Escolha um Programa");
      return false;
    }

    if (this.nome == undefined || this.nome == "") {
      this.util.toasterShowError("Atenção", "Entre com o Nome da Triagem");
      return false;
    }    

    if (this.arrayFormulario == undefined || this.arrayFormulario.length == 0) {
      this.util.toasterShowError("Atenção", "Adicione pelo menos um campo no formulario");
      return false;
    }

    return true;
  }

  salvarTemplatePerguntas(idQr: string) {
    debugger
    let dados = this.arrayFormulario.map((item) => ({ ...item, iD_TRIAGEM: idQr }));

     let options = [];
     dados.forEach(itemDados => { 
       debugger
      if (itemDados.iD_TIPO_CAMPO_FORMULARIO == 9 && itemDados.valores.length > 0) {
        let opt = itemDados.valores.map((item, index) => {
          return {...itemDados, agrupamento: itemDados.titulo, titulo: item, valores: null, ordem: index+1};
        });
        options.push(...opt);
      }
     });     

     let date = options != null ? [...dados, ...options] : dados;

    console.log("date juntos", date);
    let url = API + "CampoFormularioTriagem/CampoFormularioTriagem";
    this.util.showLoading();
    return this.ajax.post(url, date)
      .subscribe((resp: ResponseNet) => {
        debugger
        this.util.closeLoading();
        this.util.toasterShowSuccess("Sucesso", "Cadastrado com sucesso!");
        this.router.navigate(['/home']);

      }, err => {
        debugger
        this.util.closeLoading();
        this.util.messageError(err);
      });;

  }

  criarTriagem() {

    if (this.validarTriagem()) {

      this.util.showLoading();
      this.salvarTriagem()
        .subscribe((resp: ResponseNet) => {
          debugger
          this.util.closeLoading();
          this.salvarTemplatePerguntas(resp.data.iD_TRIAGEM);

        }, err => {
          debugger
          this.util.closeLoading();
          this.util.messageError(err);
        });

    }

  }

  posicao() {
    console.log(this.arrayFormulario);
  }

  salvarTriagem() {
    let dadosQrcode = {
      "iD_PROGRAMA": this.programaSelecionado,
      "titulo": this.nome
    }
    let url = API + "Triagem/Triagem";
    return this.ajax.post(url, dadosQrcode);
  }

  teste() {
    console.log(this.programaSelecionado);
  }

}
